export const dialPlanSchema = {
    name: [
        { type: 'isEmpty', message: 'Dial Plan Name cannot be left empty.' },
    ],
};

export const ruleSchema = {
    name: [{ type: 'isEmpty', message: 'Rule Name cannot be left empty.' }],
    priority: [{ type: 'isEmpty', message: 'Priority cannot be left empty.' }],
    pattern: [{ type: 'isEmpty', message: 'Pattern cannot be left empty.' }],
    translation: [
        { type: 'isEmpty', message: 'Translation cannot be left empty.' },
    ],
};
